<template>
  <div class="lg-page">
    <div class="lg-glow lg-glow--1" />
    <div class="lg-glow lg-glow--2" />

    <div class="lg-card">
      <div class="lg-brand">
        <img src="@/assets/logo.png" class="lg-brand__logo" />
      </div>

      <h1 class="lg-title">Bienvenido de vuelta</h1>
      <p class="lg-subtitle">Ingresa a tu panel de control</p>

      <div v-if="inactivityLogout" class="lg-inactivity-banner">
        <img src="@/assets/warning-sc.svg" class="lg-inactivity-icon" alt="warning" />
        <p class="lg-inactivity-text">Tu sesión se cerró por inactividad. Por favor inicia sesión nuevamente.</p>
      </div>

      <form @submit.prevent="loginUser" class="lg-form">
        <div class="lg-field">
          <label class="lg-label">Email</label>
          <input
            class="input"
            type="email"
            name="email"
            placeholder="tu@empresa.com"
            required
            autofocus=""
            autocomplete="off"
            v-model="email"
            data-testid="field-login-email"
          />
        </div>

        <div class="lg-field">
          <div class="lg-label-row">
            <label class="lg-label">Contraseña</label>
            <router-link class="lg-forgot" :to="{ name: 'forgot-password' }">¿Olvidaste tu contraseña?</router-link>
          </div>
          <div class="control has-icons-right">
            <input
              class="input"
              :type="!showPassword ? 'password' : 'text'"
              required
              placeholder="••••••••••"
              name="password"
              v-model="pass"
              data-testid="field-login-password"
              @keyup.enter="loginUser"
            />
            <a class="icon is-small is-right lg-eye" @click="viewPassword()">
              <i class="far fa-eye" v-if="!showPassword" />
              <i class="far fa-eye-slash" v-else />
            </a>
          </div>
        </div>

        <div class="lg-error" v-if="error">{{ error }}</div>

        <button
          type="submit"
          class="lg-btn"
          :class="{ 'is-loading': loading }"
          data-testid="action-login-getIn"
        >
          Iniciar sesión
        </button>
      </form>
    </div>

    <p class="lg-tagline">Smart Native</p>

    <modal-confirmacion-cuenta
      v-if="modalConfirmAccount"
      :close="openModalAccountConfirm"
      :email="email"
      :token="token"
      :token_invalid="token_invalid"
    />

    <div class="modal" :class="{ 'is-active': showActiveSessionModal }">
      <div class="modal-background" @click="closeActiveSessionModal"></div>
      <div class="modal-card active-session-modal">
        <section class="modal-card-body">
          <div class="session-icon-wrapper">
            <img src="@/assets/active-session.svg" alt="">
          </div>
          <h3 class="session-title">Ya tienes una sesión activa</h3>
          <p class="session-description">Detectamos que tu cuenta está abierta en otro dispositivo. Si continúas, la sesión anterior se cerrará automáticamente.</p>
          <button class="button session-confirm-btn" :class="{ 'is-loading': loading }" @click="loginWithForce">
            Iniciar sesión
          </button>
          <button class="button session-cancel-btn" @click="closeActiveSessionModal">
            Cancelar
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalConfirmacionCuenta from '@/components/Register/modal-confirmacion-cuenta.vue'
import format from '@/mixins/formats'

export default {
  name: 'Login',
  mixins: [format],
  components: {
    ModalConfirmacionCuenta
  },
  data () {
    return {
      email: null,
      pass: null,
      loading: false,
      showPassword: false,
      error: null,
      modalConfirmAccount: false,
      token: '',
      token_invalid: false,
      showActiveSessionModal: false,
      activeSessionDevice: null,
      activeSessionLastActivity: null
    }
  },
  computed: {
    inactivityLogout () {
      return this.$route.query.reason === 'inactivity'
    }
  },
  methods: {
    ...mapActions(['signin', 'getTokenConfirm']),
    async loginUser () {
      try {
        this.error = null
        this.loading = true

        const ip = await this.getClientIp()

        const resp = await this.signin({
          email: this.email,
          password: this.pass,
          ip,
          userAgent: navigator.userAgent
        })

        if (resp?.error) {
          if (resp.code === 'ACTIVE_SESSION_EXISTS') {
            this.activeSessionDevice = resp.deviceInfo
            this.activeSessionLastActivity = this.humanDate(resp.lastActivity, 'DD-MMMM-YYYY HH:mm:ss', true, 'es')
            this.showActiveSessionModal = true
          } else {
            this.error = resp.message
          }
        }
      } finally {
        this.loading = false
      }
    },
    viewPassword () {
      this.showPassword = !this.showPassword
    },
    openModalAccountConfirm () {
      this.modalConfirmAccount = !this.modalConfirmAccount
    },
    closeActiveSessionModal () {
      this.showActiveSessionModal = false
      this.activeSessionDevice = null
      this.activeSessionLastActivity = null
    },
    async loginWithForce () {
      try {
        this.loading = true
        const ip = await this.getClientIp()
        const resp = await this.signin({
          email: this.email,
          password: this.pass,
          ip,
          forceLogin: true,
          userAgent: navigator.userAgent
        })
        if (resp?.error) {
          this.showActiveSessionModal = false
          this.error = resp.message
        }
      } finally {
        this.loading = false
      }
    },
    async getClientIp () {
      try {
        const resp = await fetch('https://api.ipify.org?format=json')
        const data = await resp.json()
        return data.ip
      } catch (error) {
        return null
      }
    }
  },
  created () {
    const agentWidget = document.getElementById('agentWidget')
    agentWidget.style.display = 'none'
  },
  mounted () {
    const tokenRoute = this.$route.query.token
    if (tokenRoute) {
      this.token = tokenRoute
      this.getTokenConfirm({ token: tokenRoute })
        .then(tokenResp => {
          if (!tokenResp.error) {
            this.openModalAccountConfirm()
          } else {
            this.token_invalid = true
            this.openModalAccountConfirm()
          }
        })
        .catch(() => {
          this.token_invalid = true
          this.token = ''
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.lg-page {
  position: relative;
  min-height: 100vh;
  background: #0d1525;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 2rem;
}

.lg-glow {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;

  &--1 {
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, rgba(76, 112, 255, 0.22), transparent 65%);
    filter: blur(60px);
    top: -200px;
    right: -150px;
  }
  &--2 {
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(76, 112, 255, 0.1), transparent 70%);
    filter: blur(80px);
    bottom: -100px;
    left: -80px;
  }
}

// ── Card ─────────────────────────────────────────────────────
.lg-card {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2.5rem 2.25rem;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.5);
}

// ── Brand ────────────────────────────────────────────────────
.lg-brand {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;

  &__logo {
    width: 200px;
    opacity: 0.92;
  }
}

.lg-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0.3rem;
  text-align: center;
}

.lg-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 2rem;
  text-align: center;
}

// ── Form ─────────────────────────────────────────────────────
.lg-form {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.lg-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  .input {
    height: 35px;
  }
}

.lg-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
}

.lg-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lg-forgot {
  font-size: 0.75rem;
  color: #7b9fff;
  text-decoration: none;
  &:hover { color: #fff; text-decoration: underline; }
}

.lg-eye {
  pointer-events: all !important;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.4);
}

.lg-error {
  font-size: 0.82rem;
  color: #ff3860;
  background: rgba(255, 56, 96, 0.1);
  border: 1px solid rgba(255, 56, 96, 0.25);
  border-radius: 8px;
  padding: 0.6rem 0.85rem;
}

.lg-inactivity-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #FFF3E7;
  border-radius: 5px;
  padding: 8px 12px;
  margin-bottom: 1rem;
}

.lg-inactivity-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  margin-top: 1px;
}

.lg-inactivity-text {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #F6921E !important;
  line-height: 1.4 !important;
  margin: 0 !important;
  padding: 0 !important;
  text-align: left !important;
}

.lg-tagline {
  margin-top: 1.25rem;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.25);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.lg-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1.5rem;
  transition: background 0.2s ease, transform 0.15s ease;

  &:hover {
    background: darken(#4c70ff, 8%);
    transform: translateY(-1px);
  }
  &:active { transform: translateY(0); }

  &.is-loading {
    color: transparent;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255, 255, 255, 0.4);
      border-top-color: #fff;
      border-radius: 50%;
      animation: lg-spin 0.6s linear infinite;
    }
  }
}

@keyframes lg-spin {
  to { transform: rotate(360deg); }
}
  .active-session-modal {
    border-radius: 12px;
    overflow: hidden;
    max-width: 450px;
    width: 90%;
  }
  .active-session-modal .modal-card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 40px 32px 32px;
    background: #fff;
    border-radius: 12px;
  }
  .session-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: #ece9ff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .session-icon-wrapper .fas {
    font-size: 1.75rem;
    color: #6c63ff;
  }
  .session-title {
    font-size: 16px;
    font-weight: 700;
    color: #363636;
    margin-bottom: 12px !important;
  }
  .session-description {
    font-size: 12px;
    color: #7a7a7a;
    line-height: 1.5;
    margin-bottom: 28px !important;
  }
  .session-confirm-btn {
    width: 180px;
    margin-top: 0 !important;
    margin-bottom: 12px;
    background-color: #00c88c !important;
    border-color: #00c88c !important;
    color: #fff !important;
    border-radius: 6px;
    font-weight: 600;
    height: 44px;
  }
  .session-confirm-btn:hover {
    background-color: #00b07a !important;
    border-color: #00b07a !important;
  }
  .session-cancel-btn {
    width: 100%;
    margin-top: 0 !important;
    background: transparent !important;
    border-color: transparent !important;
    color: #4a4a4a !important;
    font-weight: 500;
    box-shadow: none !important;
  }
  .session-cancel-btn:hover {
    background: transparent !important;
    color: #363636 !important;
    text-decoration: underline;
  }
</style>
